module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABICAYAAABhlHJbAAAAAXNSR0IArs4c6QAAAUpJREFUeAHt1cFJBDEUANA/nvbsVXuwBZuxBYuwBQuwDVvYHhRve97bmC8EJGAmQmRgfQPLTPL/T/48dkiEiwABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIELg0geUvXujmeb1dz/FUFr/P9deI1+UQj+8Py9vIfnvXj/RYc6YD5svHOY4F7bpukvey0SkOcbeFuHf9955Hnq9Gkn6Tk/+8Fi/rcy5jW2vtXb/VXxufDlg/23ajHPdiNb+X04vNqq/rjN6nA45ufCl50wHzwPgJpxerNb2cXmxWfV1n9D4dME/b8qmd2gZyLmPtfDveu77tZ2s8HfDrlC2nbdn4paB95C+fR07gbHbv+uzBRYAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECPxvgU/VWHTNL4tlUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/more_active@2x.png
// module id = xyDz
// module chunks = 0